module.exports = __webpack_public_path__ + "img/other.40802765.png";